import Image from 'global/Image';

import tradingModalStore from 'global/TradingModal/store';
import { useTradingInfoStore } from 'global/Securities/stores/useTradingInfoStore';

import { ORDER_TYPE } from 'constants/trading';
import { formatHourMinutes } from 'features/day-trade/utils/formater';
import { getUnavailableReason } from 'features/day-trade/utils/common';

import {
  clevertapDayTradeAfterMarketViewed,
  clevertapDayTradeDebtRatioViewed,
  clevertapDayTradeDebtRatioSubmitted,
} from 'lib/analytics/securities';

import BaseSecuritiesModal from 'global/Securities/components/Modal/BaseSecuritiesModal';
import type { BaseSecuritiesModalProps } from 'global/Securities/components/Modal/BaseSecuritiesModal';
import { EventTypeEnum } from 'global/Securities/types/trading';

import { useEffect } from 'react';
import {
  Container,
  Description,
  ActionWrapper,
  ConfirmButton,
} from './unavailable.styled';

export default function DayTradeUnavailable({
  onCancel = () => {},
  onSubmit = () => {},
  ...props
}: BaseSecuritiesModalProps) {
  const {
    event_type: eventType,
    trading_open: tradingOpen,
    trading_close: tradingClose,
  } = useTradingInfoStore((s) => s.dayTrade);
  const { orderType } = tradingModalStore();
  const { SELL, AMEND_SELL } = ORDER_TYPE;

  const isTimeLimit = eventType === EventTypeEnum.OUTSIDE_MARKET_HOURS;
  const isSellOrder = orderType === SELL || orderType === AMEND_SELL;
  const isSellAmend = orderType === AMEND_SELL;
  const formattedTime = formatHourMinutes(tradingOpen, tradingClose).openClose;

  const imageUrl = isTimeLimit ? 'time-limit' : 'force-selling';

  const unavailableReason = getUnavailableReason(
    isTimeLimit,
    isSellOrder,
    isSellAmend,
    formattedTime,
  );

  const handleSubmit = () => {
    onSubmit();

    if (!isTimeLimit || isSellAmend) {
      clevertapDayTradeDebtRatioSubmitted();
    }
  };

  useEffect(() => {
    if (isTimeLimit && !isSellAmend) {
      clevertapDayTradeAfterMarketViewed();
    } else {
      clevertapDayTradeDebtRatioViewed();
    }
  }, [isTimeLimit, isSellAmend]);

  return (
    <BaseSecuritiesModal
      onCancel={onCancel}
      hideSubmit
      closable={false}
      modalWidth={415}
      {...props}
    >
      <Container>
        <Image
          src={`/images/day-trade/unavailable-${imageUrl}.svg`}
          alt="Day Trade Unavailable"
          height={120}
        />

        <Description>{unavailableReason}</Description>

        <ActionWrapper>
          <ConfirmButton onClick={handleSubmit} type="primary">
            Oke
          </ConfirmButton>
        </ActionWrapper>
      </Container>
    </BaseSecuritiesModal>
  );
}
